import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum UserAddressTypes {
	Billing = 'billing',
}

export interface UserAddress extends Record, Dateable {
	userId: number;
	type: string;
	firstName: string;
	lastName: string;
	companyName: string;
	email: string;
	address: string;
	city: string;
	region: string;
	postalCode: string;
	country: string;
	phoneNumber: string;
}

export interface UserAddressPayload {
	type: string;
	firstName?: string;
	lastName?: string;
	companyName?: string;
	email?: string;
	address?: string;
	city?: string;
	region?: string;
	postalCode?: string;
	country?: string;
	phoneNumber?: string;
}

export interface UserAddressCreatePayload extends UserAddressPayload {
	userId: number;
}
